module.exports = __webpack_public_path__ + "media/favicon/favicon-32x32-744553f9.png";